module.exports = __webpack_public_path__ + "static/media/pic2.255d5659.jpg";